import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';

class SubscDetailsComponents extends LitElement {

    static get properties() {
        return {
            _subscriptionDetails: { type: Object },
        }
    }

    get subscriptionDetails() {
        return this._subscriptionDetails;
    }

    set subscriptionDetails(value) {
        this._subscriptionDetails = value;
    }

    constructor() {
        super();
        document.addEventListener('onSelectSubscription', async (e) => {
            this.subscriptionDetails = e.detail.selectedSubscription;
        })
    }

    static get styles() {
        return css`
        * {
            margin: 0;
            padding: 0;
        }
        .text-center {
            text-align: center;
        }

        .disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: not-allowed;
            position: relative;
        }
        
        .mg-b5 {
            margin-bottom: 5px;
        }
        
        /* Element Style */
        .subscription-box {
            border-radius: 35px;
            position: relative;
            padding: 25px 25px;
            width: 100%;
            border: 1px solid var(--w-bg-borc, #505050);
            background-color: var(--w-bgc, #fff);
            box-sizing: border-box;
        }
        
        .subscription-heading {
            font-size: var(--w-tit-fs, 14px);
            color: var(--w-tit-col, #000);
            background-color: var(--w-tit-bgc, #fff);
            padding: 10px;
            border-radius: 5px;
        }
        
        .cdapress-section {
            background-color: var(--subscription-heading-bgColor, #fff);
            border: none;
            padding: 5px 10px;
        }
        
        .cdapress-heading {
            font-size: 14px;
            color: var(--cdapress-heading-Color, #000);
            padding: 10px;
            border-radius: 5px;
        }
        
        .cdapress {
            list-style: none;
            width: 100%;
        }
        
        .cda-box {
            display: flex;
            align-items: center;
        }
        
        .cda-right {
            width: 65%;
        }
        
        .cds-left {
            width: 35%;
        }
        
        .sub-Accountno {
            font-size: 12px;
            color: var(--sub-Accountno-Color, #000);
            padding: 10px;
            font-weight: 600;
        }
        
        .sub-Accountdetail {
            font-size: 12px;
            color: var(--sub-Accountdetail-Color, #000);
            padding: 10px;
        }
        
        @media(max-width: 767px) {
            .subscription-box {
                padding: 15px;
                border-radius: 20px;
            }
        }
        `;
    }

    render() {
        return html
            `<div id="subscription-details-widget" class=${classMap({ 'subscription-box': true, 'disabled': this.subscriptionDetails ? this.subscriptionDetails.status === 'Inactive' : false })}>
        <div class="text-center mg-b5">
            <h2 class="subscription-heading">Your Subscription</h2>
        </div>
        <div class="cdapress-section">
            <h2 class="cdapress-heading">${this.getsubscriptionDetail('name')}</h2>
            <ul class="cdapress">
            <li class="cda-box">
                    <div class="cda-right">
                        <p class="sub-Accountno">Account Number:</p>
                    </div>
                    <div class="cds-left">
                        <p class="sub-Accountdetail">${this.getsubscriptionDetail('accountNumber')}</p>
                    </div>
                </li>
                <li class="cda-box">
                    <div class="cda-right">
                        <p class="sub-Accountno">Status:</p>
                    </div>
                    <div class="cds-left">
                        <p class="sub-Accountdetail">${this.getsubscriptionDetail('status')}</p>
                    </div>
                </li>
                <li class="cda-box">
                    <div class="cda-right">
                        <p class="sub-Accountno">Date Acquired:</p>
                    </div>
                    <div class="cds-left">
                        <p class="sub-Accountdetail">${this.getsubscriptionDetail('datePurchased')}</p>
                    </div>
                </li>
                <li class="cda-box">
                    <div class="cda-right">
                        <p class="sub-Accountno">Renewal Date:</p>
                    </div>
                    <div class="cds-left">
                        <p class="sub-Accountdetail">${this.getsubscriptionDetail('expirationDate')}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>`;
    }

    renewalDate(inputDate) {
        let date = new Date(inputDate);
        inputDate = new Date(inputDate);

        inputDate.setHours(0);
        inputDate.setMinutes(0);
        inputDate.setSeconds(0);

        date.setMonth(inputDate.getUTCMonth(), inputDate.getUTCDate());
        date.setFullYear(inputDate.getUTCFullYear());
        date.setHours(inputDate.getUTCHours());
        date.setMinutes(inputDate.getUTCMinutes());
        date.setSeconds(inputDate.getUTCSeconds());
        date.setMilliseconds(inputDate.getUTCMilliseconds());

        const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        return formattedDate;
    }

    getsubscriptionDetail(detailName) {
        if (this.subscriptionDetails) {
            let text = '';
            switch (detailName) {
                case "name":
                    text = this.subscriptionDetails.name;
                    break;
                case "status":
                    text = this.subscriptionDetails.status;
                    break;
                case "accountNumber":
                    if (this.subscriptionDetails.circulationDetails?.circSystemSubscriptionId) {
                        text = this.subscriptionDetails.circulationDetails.circSystemSubscriptionId;
                    } else {
                        text = this.subscriptionDetails.subscriptionId;
                    }
                    break;
                case "datePurchased":
                    text = this.renewalDate(this.subscriptionDetails.datePurchased);
                    break;
                case "expirationDate":
                    text = this.renewalDate(this.subscriptionDetails.expirationDate);
                    break;
                default:
                    text;
            }
            return text;
        }
        return '';
    }
}

customElements.define('syncui-subs-details', SubscDetailsComponents);